import { Box } from "@mui/material";
import { t } from "i18next";
import { ContactPreviewButton } from "../../../../components/buttons/ContactPreviewButton";
import { ContactEditButton } from "../../../../components/buttons/ContactEditButton";
import BaseTable from "../../../../components/table/BaseTable";
import { useContacts } from "../../../../services/contactsService";

const HEADERS = [
    t("clients.ClientPassportContactsTable.way"),
    t("clients.ClientPassportContactsTable.subject"),
    t("clients.ClientPassportContactsTable.note"),
    t("clients.ClientPassportContactsTable.creator"),
    t("clients.ClientPassportContactsTable.date"),
    t("clients.ClientPassportContactsTable.preview"),
    t("clients.ClientPassportContactsTable.edit"),
];

export function ClientPassportContactsTable({
    personId,
    relatedContactsForClientId,
    investmentId,
    colMaxLength, 
    maxHeight
}) {
    const searchParams = relatedContactsForClientId
        ? new URLSearchParams({
                related_contacts_for_client_id: relatedContactsForClientId,
            })
        : personId
            ? new URLSearchParams({ contact_person_id: personId })
            : new URLSearchParams({});

    if (investmentId) {
        searchParams.set("investment", investmentId);
    }

    const { data: personContacts, isLoading, isFetching } = useContacts(searchParams, {
        select: (data) =>
            data?.results?.map((contact) => ({
                rowId: contact.id,
                data: [
                    t(`contacts.waysOfContact.${contact.way}`),
                    t(`contacts.subjects.${contact.subject}`),
                    contact.note || "-",
                    contact.seller ? contact.seller.full_name : t("unknown"),
                    new Date(contact.date).toLocaleDateString(),
                    <ContactPreviewButton
                        key={contact.id}
                        personId={contact.person.id}
                        rowData={{
                            way: contact.way,
                            subject: contact.subject,
                            date: contact.date,
                            note: contact.note,
                            products: contact.products,
                            offerId: contact.offer?.id,
                        }}
                    />,
                    <ContactEditButton
                        key={contact.id}
                        personId={contact.person.id}
                        rowData={{
                            id: contact.id,
                            way: contact.way,
                            subject: contact.subject,
                            date: contact.date,
                            note: contact.note,
                            products: contact.products,
                            offerId: contact.offer?.id,
                        }}
                    />,
                ],
            })) || [],
    });

    return (
        <Box sx={{ maxHeight: maxHeight|| 200, overflow: "auto", borderRadius: 1 }}>
            <BaseTable
                showLoader={isLoading || isFetching}
                stickyHeader={true}
                headers={HEADERS}
                rows={personContacts || []}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                hiddenColumns={[]}
                selectedRows={[]}
                colMaxLength={colMaxLength}
            />
        </Box>
    );
}
